<template>
    <info-screen
            class="welcomePage"
            :title="$ml.get('welcomeTitle')"
            :text="$ml.get('welcomeText')"
            :action="nextScreen"
            :buttonText="$ml.get('startButtonText')"
            :titleH1="true"
            :headerImg="0"
            :disabledButton="!isAgree"
    >
        <div class="multilang" >
            <p v-text="$ml.get('welcomeMultiLangText')"></p>
            <login-select-code
                :select-array="selectArray"
                :default-current-item="currentLang"
                @setItem="changeLang"
            />
        </div>
        <div class="agreement">
            <input type="checkbox" id="isAgreeCheckbox" v-model="isAgree" />
            <label for="isAgreeCheckbox" v-html="$ml.get('agreement')"></label>
        </div>
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import LoginSelectCode from "../../components/ui/login-select-code";
    import Profile from '../../helpers/profile'
    import {login as apiLogin, getApiErrorMessage} from '../../helpers/api'
    export default {
        name: "loginWelcome",
        components: {LoginSelectCode, InfoScreen},
        data() {
            return {
                selectArray: [
                    {
                        logo: '<img src="../static/flags/uk.png" alt="Українська">',
                        name: 'Українська',
                        lang: 'uk'
                    },{
                        logo: '<img src="../static/flags/ru.png" alt="Русский">',
                        name: 'Русский',
                        lang: 'ru'
                    },{
                        logo: '<img src="../static/flags/en.png" alt="English">',
                        name: 'English',
                        lang: 'en'
                    },
                ],
                isAgree: false,
            }
        },
        beforeRouteEnter (to, from, next) {
            if (!from.name && window.LoginHint) {
                let hint = window.LoginHint.replace(/\D/,'');
                if (/^380[0-9]{9}$/.test(hint)) {
                    let data = {otptype: 'sms', username: hint };
                    Profile.setData(data);
                    apiLogin(data).then((resp) => {
                        next(vm => {
                            vm.$router.push({ name: Profile.registration ? 'LoginSendCodeForRegistration' :
                                'LoginSendCode'});
                        });
                    }, () => {
                        next();
                    });
                } else
                    next();
            } else
                next();
        },
        computed: {
            currentLang: function () {
                return this.selectArray.findIndex((item)=>{return item.lang == this.$ml.current});
            },
        },
        methods: {
            nextScreen: function () {
                this.$router.push({ name: 'LoginEnterLogin'});
            },
            changeLang: function (data) {
                Profile.language = data.lang;
                this.$ml.change(data.lang)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .multilang {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        p {
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
        }
    }

</style>

<style lang="scss">
    .agreement {
        font-weight: 300;
        #isAgreeCheckbox {
            float: left;
            padding: initial;
            box-shadow: initial;
            -webkit-appearance: checkbox;
        }
        label {
            font-size: 12px;
            line-height: 1.4em;
            margin-left: 24px;
            display: block;
            a {
                font-size: 12px;
                line-height: 1.5em;
            }
        }
    }
    @media (max-width: 600px) {
        .welcomePage {
            .logoPage.fullImg {
                height: 100px;
            }
            .infoScreen_content {
                height: calc(100vh - 214px);
            }
        }
    }
</style>